import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Icon, Tooltip } from 'antd';
import { AiOutlineSend } from 'react-icons/ai';
import cn from 'classnames';
import { useSubmit } from './SubmitProvider';
import { isSubmitMsgDisabledSelector } from '../../store/selectors';
import styles from './PostMessageForm.module.scss';

const Btn = (props) => <Button {...props} />;

const SubmitBtn = () => {
  const disabled = useSelector(isSubmitMsgDisabledSelector);
  const { loading, onSubmit } = useSubmit();

  return (
    <Tooltip title="Отправить сообщение">
      <Btn
        disabled={disabled || loading}
        onClick={onSubmit}
        className={cn(styles.btn, styles.submitBtn)}
      >
        {loading ? <Icon type="loading" /> : <AiOutlineSend />}
      </Btn>
    </Tooltip>
  );
};

export default SubmitBtn;
